// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"459":"4e09a8e9","470":"708d5abb"}[chunkId] + ".chunk.css";
};